window.$ = require('jquery');
$(function() {
 "use strict";
    let LOCAL_STROAGE_THEME_KEY = "selected_theme";
     function filteraskquestiontobot()
     {
        let question = getCleanValue("input-text-item");
        if(question.length < 1)
        {
          showHtmlMessage("Validation Error", `Please enter your question`,'error');
          return false;
       }

       if(question.length > 1000)
       {
         showHtmlMessage("Validation Error", `Please limit your question to less than 1000 chars. Your input contains ${question.length} chars.`,'error');
         return false;
       }

       let isfound = false;
       // for(keyword of keywords)
       // {
       //   let question_text = question.toLowerCase();
       //   let keyword_text = keyword.keyword.toLowerCase();
       //   if(kmpSearch(keyword_text, question_text) !== -1)
       //   {
       //      isfound = true;
       //      let modalid = `userloging${getRandomNumber()}`;
       //      let modalHtmlContent = `
       //                   <div class="modal fade" id="${modalid}" tabindex="-1"  aria-labelledby="${modalid}Title" aria-hidden="true"  data-bs-backdrop="static" data-bs-keyboard="false">
       //                       <div class="modal-dialog modal-dialog-centered modal-md">
       //                           <div class="modal-content">
       //                               <div class="modal-header" data-bs-theme="dark">
       //                                   <h5 class="modal-title" id="${modalid}LongTitle">${keyword.keyword_prompt_title}</h5>
       //                                   <button type="button" class="btn-close btn-close-white"  aria-label="Close" onclick="processkeywordfilter('${modalid}','${question}')"></button>
       //                               </div>
       //                               <div class="modal-body">
       //                                   <div class="mb-2">${keyword.keyword_prompt_text}</div>
       //                                   <div class="flex-end">
       //                                       <a href="${keyword.keyword_redirect_url}" class="btn btn-popup-login">Yes</a> &nbsp;&nbsp; <a href="javascript:;" onclick="processkeywordfilter('${modalid}','${question}')" class="btn btn-secondary">No</a>
       //                                   </div>
       //                               </div>
       //                               <div class="modal-footer mb-2 flex-space-between">
       //                               </div>
       //                           </div>
       //                       </div>
       //                   </div>`;
       //
       //          $(modalHtmlContent).appendTo('body');
       //            setTimeout(function () {
       //             showModal(modalid);
       //           },500);
       //           break;
       //       }
       //    }

          if(isfound === false)
          {
              $("#input-text-item").val("");
             askquestiontobot(question)
          }
     }

     function askquestiontobot(question)
     {
         let questionId = getRandomNumber();
         let questionsanswer = `<div id="questions" class="relative mx-auto  max-w-2xl px-4 my-4" style="margin-top: 40px">
             <div>
                 <div class="group relative message-container sm:ml-4">
                     <div class="bg-background flex size-[25px] shrink-0 select-none items-center justify-center rounded-md border shadow-sm">
                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor" class="size-4 message-container-icon">
                             <path
                                 d="M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8ZM72 96a56 56 0 1 1 56 56 56.06 56.06 0 0 1-56-56Z"
                             ></path>
                         </svg>
                     </div>
                     <div class="message-container-body flex-1 space-y-2 overflow-hidden pl-2">${question}</div>
                 </div>
                 <div data-orientation="horizontal" role="none" class="shrink-0 bg-border h-[0px] w-full my-4"></div>
             </div>
             <div>
                 <div class="group relative message-container sm:ml-4">
                     <div class="bg-primary message-container-icon text-primary-foreground flex size-[24px] shrink-0 select-none items-center justify-center rounded-md border shadow-sm">
                         <img src="chatilm-ai-icon.png" width="24" height="23" alt="ai icon">
                     </div>
                     <div  class="message-container-body flex-1 space-y-1 overflow-hidden px-1">
                         <div id="${questionId}_body" class="break-words">
                             <svg id="${questionId}_loading"
                                 fill="none"
                                 stroke="currentColor"
                                 strokeWidth="1.5"
                                 viewBox="0 0 24 24"
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 xmlns="http://www.w3.org/2000/svg"
                                 class="size-4 animate-spin stroke-zinc-400"
                             >
                                 <path d="M12 3v3m6.366-.366-2.12 2.12M21 12h-3m.366 6.366-2.12-2.12M12 21v-3m-6.366.366 2.12-2.12M3 12h3m-.366-6.366 2.12 2.12"></path>
                             </svg>
                         </div>
                         <div id="${questionId}_share" class="share-buttons">
                             
                         </div>
                     </div>
                 </div>

             </div>
         </div>`;

         if($("#suggest-questions"))
         {
             $("#suggest-questions").remove();
         }

         $(questionsanswer).appendTo("#question_answers");
         $(".right-content")[0].scrollTop = $(".right-content")[0].scrollHeight;

         // let api_url = "https://xerodigit.dev/ajaxhelper.php";
         //
         // const eventSource = new EventSource('https://xerodigit.dev/ajaxhelper.php?question='+question);
         // // const eventSource = new EventSource('http://localhost:5000/');
         // const outputDiv = document.getElementById(`${questionId}_body`);
         // while(outputDiv.firstChild){
         //     //outputDiv.removeChild(outputDiv.firstChild);
         // }
         //
         // eventSource.onmessage = function(event) {
         //        outputDiv.append(event.data);
         // };
         //
         // eventSource.onerror = function() {
         //     eventSource.close();
         // };

         //new EventSource('https://xerodigit.dev/ajaxhelper.php?question='+question);
         const eventSource = new EventSource('https://xerodigit.dev/ajaxhelper.php?question='+question);//new EventSource("https://chatilm.azurewebsites.net/sunnah_bot",{Question:`${question}`,queries: "[]",flag:"True"});
         const outputDiv = document.getElementById(`${questionId}_body`);
         let p = document.createElement("p");
         outputDiv.append(p);
         eventSource.onmessage = function(event) {

                if(event.data !== "None")
                {
                    let output = event.data.toString();

                    p.append(output);


                    //outputDiv.append(output);
                    if(output === ".")
                    {
                        //let p = document.createElement("p");
                        //let space = document.createElement("br");
                        //p.append(space);
                        //outputDiv.append(p);

                        p = document.createElement("p");
                        outputDiv.append(p);


                    }
                    $(".right-content")[0].scrollTop = $(".right-content")[0].scrollHeight;
                }
                else
                {
                    $(`#${questionId}_body`).html(getfiltercontent(outputDiv.innerHTML));
                    $(`#${questionId}_share`).html(getShareLinks(questionId,""));

                }
         }

         eventSource.onerror = function(e) {
             console.log(e);
             if($(`#${questionId}_loading`))
             {
                 $(`#${questionId}_loading`).remove();
             }
             $(`#${questionId}_body`).html(getfiltercontent(outputDiv.innerHTML));
             eventSource.close();
         }

         // onopen version
         eventSource.onopen = (e) => {
             if($(`#${questionId}_loading`))
             {
                 $(`#${questionId}_loading`).remove();
             }
             console.log("The connection has been established.");
         };

     }

     function getShareLinks(questionId,questionAnswer)
     {
         return `
            <a class="share-button-item">
                                 <svg width="37" height="36" viewBox="0 0 37 36" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                     <mask id="mask0_2317_1742" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="7" y="7" width="23" height="22">
                                         <rect x="7.60632" y="7.17847" width="21.5358" height="21.5358" fill="currentColor"/>
                                     </mask>
                                     <g mask="url(#mask0_2317_1742)">
                                         <path d="M23.7582 26.0225H13.8876V14.3572L20.1689 8.07593L21.2906 9.19759C21.3953 9.30227 21.4813 9.44435 21.5486 9.62382C21.6159 9.80328 21.6495 9.97527 21.6495 10.1398V10.4538L20.6625 14.3572H26.4502C26.9288 14.3572 27.3475 14.5367 27.7065 14.8956C28.0654 15.2545 28.2449 15.6733 28.2449 16.1519V17.9465C28.2449 18.0512 28.2299 18.1634 28.2 18.283C28.1701 18.4027 28.1402 18.5148 28.1103 18.6195L25.4183 24.9457C25.2837 25.2448 25.0594 25.499 24.7453 25.7084C24.4312 25.9178 24.1022 26.0225 23.7582 26.0225ZM15.6823 24.2278H23.7582L26.4502 17.9465V16.1519H18.3743L19.5857 11.2166L15.6823 15.1199V24.2278ZM13.8876 14.3572V16.1519H11.1957V24.2278H13.8876V26.0225H9.401V14.3572H13.8876Z" fill="currentColor"/>
                                     </g>
                                 </svg>
                             </a>
                             <a class="share-button-item">
                                 <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <mask id="mask0_2317_89" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="7" y="7" width="23" height="22">
                                         <rect x="7.49939" y="7.17847" width="21.5358" height="21.5358" fill="currentColor"/>
                                     </mask>
                                     <g mask="url(#mask0_2317_89)">
                                         <path d="M12.8834 9.87061H22.754V21.5359L16.4727 27.8171L15.351 26.6955C15.2463 26.5908 15.1603 26.4487 15.093 26.2692C15.0257 26.0898 14.9921 25.9178 14.9921 25.7533V25.4392L15.9791 21.5359H10.1914C9.71281 21.5359 9.29406 21.3564 8.93512 20.9975C8.57619 20.6385 8.39673 20.2198 8.39673 19.7412V17.9465C8.39673 17.8419 8.41168 17.7297 8.44159 17.61C8.47151 17.4904 8.50142 17.3782 8.53133 17.2736L11.2233 10.9474C11.3579 10.6483 11.5822 10.394 11.8963 10.1847C12.2104 9.97529 12.5394 9.87061 12.8834 9.87061ZM20.9593 11.6653H12.8834L10.1914 17.9465V19.7412H18.2673L17.0559 24.6765L20.9593 20.7731V11.6653ZM22.754 21.5359V19.7412H25.4459V11.6653H22.754V9.87061H27.2406V21.5359H22.754Z" fill="currentColor"/>
                                     </g>
                                 </svg>
                             </a>
                             <a class="share-button-item">
                                 <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <mask id="mask0_2317_1751" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="7" y="7" width="22" height="22">
                                         <rect x="7.39246" y="7.17847" width="21.5358" height="21.5358" fill="currentColor"/>
                                     </mask>
                                     <g mask="url(#mask0_2317_1751)">
                                         <path d="M23.5444 26.9197C22.7966 26.9197 22.161 26.658 21.6376 26.1345C21.1141 25.6111 20.8524 24.9755 20.8524 24.2277C20.8524 24.123 20.8599 24.0146 20.8748 23.9024C20.8898 23.7903 20.9122 23.6893 20.9421 23.5996L14.616 19.9205C14.3617 20.1449 14.0776 20.3206 13.7635 20.4477C13.4494 20.5748 13.1204 20.6384 12.7765 20.6384C12.0287 20.6384 11.3931 20.3767 10.8696 19.8532C10.3462 19.3298 10.0845 18.6942 10.0845 17.9464C10.0845 17.1986 10.3462 16.563 10.8696 16.0396C11.3931 15.5162 12.0287 15.2544 12.7765 15.2544C13.1204 15.2544 13.4494 15.318 13.7635 15.4451C14.0776 15.5722 14.3617 15.748 14.616 15.9723L20.9421 12.2933C20.9122 12.2035 20.8898 12.1026 20.8748 11.9904C20.8599 11.8782 20.8524 11.7698 20.8524 11.6651C20.8524 10.9174 21.1141 10.2817 21.6376 9.75831C22.161 9.23486 22.7966 8.97314 23.5444 8.97314C24.2921 8.97314 24.9278 9.23486 25.4512 9.75831C25.9746 10.2817 26.2364 10.9174 26.2364 11.6651C26.2364 12.4129 25.9746 13.0485 25.4512 13.5719C24.9278 14.0954 24.2921 14.3571 23.5444 14.3571C23.2004 14.3571 22.8714 14.2935 22.5573 14.1664C22.2433 14.0393 21.9591 13.8636 21.7049 13.6392L15.3787 17.3183C15.4086 17.408 15.431 17.509 15.446 17.6211C15.461 17.7333 15.4684 17.8417 15.4684 17.9464C15.4684 18.0511 15.461 18.1595 15.446 18.2717C15.431 18.3839 15.4086 18.4848 15.3787 18.5745L21.7049 22.2536C21.9591 22.0292 22.2433 21.8535 22.5573 21.7264C22.8714 21.5993 23.2004 21.5357 23.5444 21.5357C24.2921 21.5357 24.9278 21.7974 25.4512 22.3209C25.9746 22.8443 26.2364 23.4799 26.2364 24.2277C26.2364 24.9755 25.9746 25.6111 25.4512 26.1345C24.9278 26.658 24.2921 26.9197 23.5444 26.9197ZM23.5444 12.5625C23.7986 12.5625 24.0117 12.4765 24.1837 12.3045C24.3557 12.1325 24.4417 11.9194 24.4417 11.6651C24.4417 11.4109 24.3557 11.1978 24.1837 11.0258C24.0117 10.8538 23.7986 10.7678 23.5444 10.7678C23.2901 10.7678 23.077 10.8538 22.905 11.0258C22.733 11.1978 22.647 11.4109 22.647 11.6651C22.647 11.9194 22.733 12.1325 22.905 12.3045C23.077 12.4765 23.2901 12.5625 23.5444 12.5625ZM12.7765 18.8437C13.0307 18.8437 13.2438 18.7577 13.4158 18.5858C13.5878 18.4138 13.6738 18.2007 13.6738 17.9464C13.6738 17.6922 13.5878 17.4791 13.4158 17.3071C13.2438 17.1351 13.0307 17.0491 12.7765 17.0491C12.5222 17.0491 12.3091 17.1351 12.1371 17.3071C11.9651 17.4791 11.8791 17.6922 11.8791 17.9464C11.8791 18.2007 11.9651 18.4138 12.1371 18.5858C12.3091 18.7577 12.5222 18.8437 12.7765 18.8437ZM23.5444 25.125C23.7986 25.125 24.0117 25.039 24.1837 24.867C24.3557 24.6951 24.4417 24.4819 24.4417 24.2277C24.4417 23.9735 24.3557 23.7603 24.1837 23.5884C24.0117 23.4164 23.7986 23.3304 23.5444 23.3304C23.2901 23.3304 23.077 23.4164 22.905 23.5884C22.733 23.7603 22.647 23.9735 22.647 24.2277C22.647 24.4819 22.733 24.6951 22.905 24.867C23.077 25.039 23.2901 25.125 23.5444 25.125Z" fill="currentColor"/>
                                     </g>
                                 </svg>

                             </a>
                             <a class="share-button-item">
                                 <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <mask id="mask0_2317_1728" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="7" y="7" width="22" height="22">
                                         <rect x="7.28552" y="7.17847" width="21.5358" height="21.5358" fill="currentColor"/>
                                     </mask>
                                     <g mask="url(#mask0_2317_1728)">
                                         <path d="M18.0534 25.125C17.5599 25.125 17.1374 24.9493 16.786 24.5979C16.4345 24.2464 16.2588 23.8239 16.2588 23.3304C16.2588 22.8369 16.4345 22.4144 16.786 22.0629C17.1374 21.7115 17.5599 21.5357 18.0534 21.5357C18.547 21.5357 18.9695 21.7115 19.3209 22.0629C19.6724 22.4144 19.8481 22.8369 19.8481 23.3304C19.8481 23.8239 19.6724 24.2464 19.3209 24.5979C18.9695 24.9493 18.547 25.125 18.0534 25.125ZM18.0534 19.7411C17.5599 19.7411 17.1374 19.5654 16.786 19.2139C16.4345 18.8625 16.2588 18.44 16.2588 17.9464C16.2588 17.4529 16.4345 17.0304 16.786 16.679C17.1374 16.3275 17.5599 16.1518 18.0534 16.1518C18.547 16.1518 18.9695 16.3275 19.3209 16.679C19.6724 17.0304 19.8481 17.4529 19.8481 17.9464C19.8481 18.44 19.6724 18.8625 19.3209 19.2139C18.9695 19.5654 18.547 19.7411 18.0534 19.7411ZM18.0534 14.3571C17.5599 14.3571 17.1374 14.1814 16.786 13.8299C16.4345 13.4785 16.2588 13.056 16.2588 12.5625C16.2588 12.0689 16.4345 11.6465 16.786 11.295C17.1374 10.9435 17.5599 10.7678 18.0534 10.7678C18.547 10.7678 18.9695 10.9435 19.3209 11.295C19.6724 11.6465 19.8481 12.0689 19.8481 12.5625C19.8481 13.056 19.6724 13.4785 19.3209 13.8299C18.9695 14.1814 18.547 14.3571 18.0534 14.3571Z" fill="currentColor"/>
                                     </g>
                                 </svg>
                             </a>         
         `;
     }

     function kmpSearch(pattern, text) {
       if (pattern.length == 0)
        return 0; // Immediate match

       // Compute longest suffix-prefix table
       var lsp = [0]; // Base case
       for (var i = 1; i < pattern.length; i++) {
        var j = lsp[i - 1]; // Start by assuming we're extending the previous LSP
        while (j > 0 && pattern[i] !== pattern[j])
         j = lsp[j - 1];
        if (pattern[i] === pattern[j])
         j++;
        lsp.push(j);
       }

       // Walk through text string
       var j = 0; // Number of chars matched in pattern
       for (var i = 0; i < text.length; i++) {
        while (j > 0 && text[i] != pattern[j])
         j = lsp[j - 1]; // Fall back in the pattern
        if (text[i]  == pattern[j]) {
         j++; // Next char matched, increment position
         if (j == pattern.length)
          return i - (j - 1);
        }
       }
       return -1; // Not found
     }

    function getRandomNumber() {
        return Math.floor(Math.random() * 9999999999)
    }

    function saveToLocalStroage(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    function getFromLocalStroage(key) {
        var value = localStorage.getItem(key);
        if (value != null) {
            return JSON.parse(value);
        }
        return null;
    }

    /* Alert Functions */
    function showHtmlMessage(title,message,type='success')
    {
        // Swal.fire({
        //     icon: type,
        //     title: title,
        //     html: message
        // });
        alert(message);
    }

    function toggleTheme()
    {

        if($("html").hasClass("dark"))
        {
            saveToLocalStroage(LOCAL_STROAGE_THEME_KEY,"");
            $("html").removeClass("dark");
        }
        else
        {
            $("html").addClass("dark");
            saveToLocalStroage(LOCAL_STROAGE_THEME_KEY,"dark");
        }
    }

    function toggleSidebar()
    {
        let windowwidth = $(window).innerWidth();
        let sideBar = $(".side-bar");
        if(windowwidth < 1024 && sideBar !== undefined)
        {
            if(sideBar.hasClass("hidden"))
            {
                sideBar.removeClass("hidden");
                if(!sideBar.hasClass("z-index-100"))
                {
                    sideBar.addClass("z-index-100")
                }
            }
            else
            {
                if(sideBar.hasClass("z-index-100"))
                {
                    sideBar.removeClass("z-index-100")
                }
                sideBar.addClass("hidden");
            }
            adjustSidebarButton();
        }
        else if(windowwidth >=1024 && sideBar !== undefined)
        {
            if(sideBar.attr("data-state") === "close")
            {
                sideBar.attr("data-state","open");
            }
            else
            {
                sideBar.attr("data-state","close");
            }
            adjustSidebarButton();
        }
    }

    function adjustSidebarButton()
    {
        let windowwidth = $(window).innerWidth();
        let sideBar = $(".side-bar");

        if(windowwidth < 1024 && sideBar !== undefined)
        {
            $('.btn-sidebar-toggle').each(function (e) {
                if($(this).attr("data-button") === "next")
                {
                    if(sideBar.hasClass("hidden"))
                    {
                        if($(this).hasClass("hidden"))
                        {
                            $(this).removeClass("hidden")
                        }
                    }
                    else
                    {
                        if(!$(this).hasClass("hidden"))
                        {
                            $(this).addClass("hidden")
                        }
                    }
                }
            });
        }
        else if(windowwidth >=1024 && sideBar !== undefined)
        {
            $('.btn-sidebar-toggle').each(function (e) {
                if($(this).attr("data-button") === "next")
                {
                    if(sideBar.attr("data-state") === "close")
                    {
                        if($(this).hasClass("hidden"))
                        {
                            $(this).removeClass("hidden")
                        }
                    }
                    else
                    {
                        if(!$(this).hasClass("hidden"))
                        {
                            $(this).addClass("hidden")
                        }
                    }
                }
            });
        }
    }

    function getCleanValue(idName) {
        return cleanhtmlspecialchars($(`#${idName}`).val());
    }
    function cleanhtmlspecialchars(inputstring) {
        if (inputstring == undefined) {
            return '';
        }
        return inputstring
            .replace('&', '&amp;')
            .replace('"', '&quot;')
            .replace("'", '&#039;')
            .replace('<', '&lt;')
            .replace('>', '&gt;');
    }

    function getfiltercontent(content)
    {
        const regexRules0 = /Chapter \d*, Verse \d*-\d*/g;

        const regexRules1 = /Chapter \d*, Verse \d*/g;

        const regexRules2 = /Chapter \d*/g;

        const regexRules3_verse_range = /\d*:\d*-\d*/g;

        const regexRules3 = /\d*:\d*/g;

        const regexRules4 = /\(https:\/\/islamicity.org\/quran\/\d*\/\d*\)/;

        //const regexRules5 = /\*.[^*]*[$*]\*/g;

        let label_key_value = [];
        let quranliketype4 = content.match(regexRules4);
        if(quranliketype4 != null)
        {
            content = content.replaceAll(quranliketype4[0],"");
        }
        let quranliketype0 = content.matchAll(regexRules0);
        for (const match of quranliketype0) {
            let chapterverse = match[0].split(",");
            let chapter = chapterverse[0].replace("Chapter ","");
            let key = 'quranliketype0_' + getRandomNumber();
            let key_value = {
                'key': key,
                'label': match[0]
            };
            label_key_value.push(key_value);
            let link = `<a class="deep-link" href="https://www.islamicity.org/quran/${parseInt(chapter)}" target="_blank">${key}</a>`;
            content = content.replaceAll(match[0],link);
        }
        let quranliketype1 = content.matchAll(regexRules1);

        for (const match of quranliketype1) {
            let chapterverse = match[0].split(",");
            let chapter = chapterverse[0].replace("Chapter ","");
            let verse = chapterverse[1].replace("Verse ","");
            if(chapter !== "" && verse !== "")
            {
                let key = 'quranliketype1_' + getRandomNumber();
                let key_value = {
                    'key': key,
                    'label': match[0]
                };
                label_key_value.push(key_value);
                let link = `<a  class="external-link deep-link" href="https://www.islamicity.org/quran/${parseInt(chapter)}/${parseInt(verse)}" target="_blank">${key}</a>`;
                content = content.replaceAll(match[0],link);
            }
        }
        let quranliketype2 = content.matchAll(regexRules2);

        for (const match of quranliketype2) {
            let chapter = match[0].replace("Chapter ","");
            if(chapter !== "")
            {
                let key = 'quranliketype2_' + getRandomNumber();
                let key_value = {
                    'key': key,
                    'label': match[0]
                };
                label_key_value.push(key_value);
                let link = `<a class="deep-link" href="https://www.islamicity.org/quran/${parseInt(chapter)}" target="_blank">${key}</a>`;
                content = content.replaceAll(match[0],link);
            }
        }

        let quranlinktypeverse_range = content.matchAll(regexRules3_verse_range);
        for (const match of quranlinktypeverse_range) {
            let chapterverse = match[0].split(":");
            let chapter = parseInt(chapterverse[0]);
            let verse = chapterverse[1];
            if(chapter > 0 && verse != "0")
            {
                let key = 'quranliketype3_range_' + getRandomNumber();
                let key_value = {
                    'key': key,
                    'label': match[0]
                };
                label_key_value.push(key_value);
                let link = `<a class="deep-link" href="https://www.islamicity.org/quransearch/?q=${chapter}%3A${verse}" target="_blank">${key}</a>`;
                content = content.replaceAll(match[0],link);
            }
        }

        let quranliketype3 = content.matchAll(regexRules3);
        for (const match of quranliketype3) {
            let chapterverse = match[0].split(":");
            let chapter = parseInt(chapterverse[0]);
            let verse = parseInt(chapterverse[1]);
            if(chapter > 0 && verse > 0)
            {
                let key = 'quranliketype3_' + getRandomNumber();
                let key_value = {
                    'key': key,
                    'label': match[0]
                };
                label_key_value.push(key_value);
                let link = `<a class="deep-link" href="https://www.islamicity.org/quran/${chapter}/${verse}" target="_blank">${key}</a>`;
                content = content.replaceAll(match[0],link);
            }
        }

        //hadith filter
        const regexRules5 = /\[[^[]*\]/g;
        let hadith_list = content.matchAll(regexRules5);
        for (const match of hadith_list) {
            let match_rules = /\b(bukhari|muslim|nasai|nasa\'i|dawud|at-tirmidhi|tirmidhi|majah|malik|ahmad|as-salihin|salihin)\b/gi;
            let key = match[0].replaceAll("Hadith Reference:","").trim();
            if(match_rules.test(match[0])){
                let link = `<a class="deep-link" href="https://www.islamicity.org/hadith/search/?q=${key}" target="_blank">${match[0]}</a>`;
                content = content.replaceAll(match[0],link);
            }
        }

        content = content.replaceAll("[","").replaceAll("]","");

        for(const suraayah of label_key_value)
        {
            content = content.replace(suraayah["key"],suraayah["label"]);
        }

        return content;

    }

    $(document).ready(function () {

      $('#input-text-item').keypress(function(event){
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode == '13'){
          event.preventDefault();
          filteraskquestiontobot();
        }
        event.stopPropagation();
      });

      $('.button-send-message').on("click", function(event){
            filteraskquestiontobot();
      });
      $(".toggle-theme").on("click", function (){
           toggleTheme();
      });
       //set selected theme
      let theme = getFromLocalStroage(LOCAL_STROAGE_THEME_KEY);
      if(theme === null || theme === "")
      {
           $("html").attr("class","");
      }
      else
      {
          $("html").attr("class",theme);
      }

      $(".btn-sidebar-toggle").on("click", function (){
        toggleSidebar();
      });

      $( window ).on( "resize", function() {
          adjustSidebarButton();
      });

      adjustSidebarButton();

    });
})


